import React from 'react'
import logo from '../../assets/logowhite.png'
import { Link } from 'react-router-dom';
import { HiMail } from "react-icons/hi";
import { ImPhone } from "react-icons/im";
import { PiMapPinFill } from "react-icons/pi";
import { MdHomeFilled } from "react-icons/md";
import { FaLinkedin } from "react-icons/fa";
import { IoLogoWhatsapp } from "react-icons/io";

const Footer = () => {
    return (
        <div className="relative text-white mt-0">
            {/* Wavy Top Effect */}
            <div className="absolute inset-0 w-full overflow-hidden leading-none">
                <svg viewBox="0 0 736 268" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M736 0C387.5 32 342.5 33.5 0 0V268H736V0Z" fill="#262626" />
                </svg>
            </div>

            {/* Footer Content */}
            <div className="px-20 pt-24 pb-10 z-1 relative bigscreen text-sm">

                <div className="grid grid-cols-[auto_auto] gap-10">

                    <div className='flex flex-col gap-8'>
                        <Link className='h-14' to='/'>
                            <img src={logo} className='h-full object-contain' />
                        </Link>

                        <div className='flex gap-3'>
                            <MdHomeFilled className="text-2xl text-white" />
                            <FaLinkedin className="text-2xl text-white" />
                            <IoLogoWhatsapp className="text-2xl text-white" />
                        </div>
                    </div>

                    <div className='grid grid-cols-3'>

                        <div>
                            <div className="text-base font-semibold mb-4">Links</div>
                            <div className="flex items-center gap-3 mb-3">
                                <Link to='/blogs'>Blogs</Link>
                            </div>
                            <div className="flex items-center gap-3 mb-3">
                                <Link to='https://hunthigh.in/contact-us/' target='_blank'>Contact Us</Link>
                            </div>
                            <div className="flex items-center gap-3 mb-3">
                                <span>Privacy Policy</span>
                            </div>
                            <div className="flex items-center gap-3 mb-3">
                                <span>Terms & Conditions</span>
                            </div>
                        </div>

                        <div>
                            <div className="text-base font-semibold mb-4">Representative Offices</div>
                            <div className="flex items-center gap-3 mb-3">
                                {/* <PiMapPinFill className="text-lg text-[#fff]" /> */}
                                <span>London</span>
                            </div>
                            <div className="flex items-center gap-3 mb-3">
                                {/* <PiMapPinFill className="text-lg text-[#fff]" /> */}
                                <span>Dubai</span>
                            </div>
                            <div className="flex items-start gap-3 mb-3">
                                {/* <PiMapPinFill className="text-lg text-[#fff]" /> */}
                                <span>Riyadh</span>
                            </div>
                            <div className="flex items-start gap-3 mb-3">
                                {/* <PiMapPinFill className="text-lg text-[#fff]" /> */}
                                <span>Mumbai</span>
                            </div>
                            <div className="flex items-start gap-3 mb-3">
                                {/* <PiMapPinFill className="text-lg text-[#fff]" /> */}
                                <span>Kolkata</span>
                            </div>
                        </div>

                        <div>
                            <div className="text-base font-semibold mb-4">Contact Us</div>
                            <Link className="flex items-center gap-3 mb-3" to='mailto:admin@hunthigh.in'>
                                <HiMail className="text-lg text-[var(--primary)]" />
                                <span>admin@hunthigh.in</span>
                            </Link>
                            <Link className="flex items-center gap-3 mb-3" to='tel:+918143518888'>
                                <ImPhone className="text-lg text-[var(--primary)]" />
                                <span>8143518888</span>
                            </Link>
                            <div className="flex items-start gap-3">
                                <PiMapPinFill className="text-lg text-[var(--primary)]" />
                                <span>84/a Gokul Plots, <br />KPHB 9th Phase, <br />Hyderabad 500085</span>
                            </div>
                        </div>
                    </div>

                </div>


                <div className="flex justify-center items-center mt-20">
                    <p>© 2025 HH For Careers. All rights reserved.</p>
                </div>
            </div>
        </div>
    );
};

export default Footer;
